import ZolBakfarApp from './ZolBakfarApp';

function App() {
  return <ZolBakfarApp />;
}

export default App;
